import React from 'react';
import './Footer.css';


const Footer = () => {
    return (
        <div>
            <div className="footer-section">
                <p><span >&copy; </span> <span className='developer'><a target="_blank" href="https://www.linkedin.com/in/codermdshakil/"> Md.Shakil Ahmed</a> </span> | Programming Hero Learner -2022   </p>
            </div>
        </div>
    );
};

export default Footer;